var Handlebars = require("/Users/Shanfan/enhancer/widget-configurator/enhancer-echarts/node_modules/.npminstall/handlebars/4.0.6/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div>\n	<div class=\"datasource-config-panel\"></div>\n	<div class=\"chart-options-panel\">\n		\n	</div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/index.html
// module id = 7
// module chunks = 0